function compactLines(content) {
  return content.split('\n').map((line) => line.trim()).filter(Boolean)
}

function pushList(blocks, lines, ordered) {
  const pattern = ordered ? /^\d+\.\s+/ : /^[-*]\s+/
  blocks.push({
    type: 'list',
    style: ordered ? 'ordered' : 'unordered',
    items: lines.map((line) => line.replace(pattern, '')),
  })
}

export function pushTextPart(blocks, content) {
  const lines = compactLines(content)
  if (!lines.length) return

  const heading = /^(#{1,4})\s+(.+)$/.exec(lines[0])
  if (heading) {
    blocks.push({ type: 'heading', level: heading[1].length, content: heading[2] })
    if (lines.length > 1) pushTextPart(blocks, lines.slice(1).join('\n'))
    return
  }

  if (lines.every((line) => /^\d+\.\s+/.test(line))) {
    pushList(blocks, lines, true)
    return
  }

  if (lines.every((line) => /^[-*]\s+/.test(line))) {
    pushList(blocks, lines, false)
    return
  }

  blocks.push({ type: 'markdown', content: lines.join('\n') })
}

export function pushMarkdown(blocks, content) {
  const trimmed = content.trim()
  if (!trimmed) return
  for (const part of trimmed.split(/\n{2,}/)) pushTextPart(blocks, part.trim())
}
